import moment from 'moment-timezone'; 
/**
 * Converts the data results to csv format and exports to file.
 */
export async function GenerateCSV(fileName: string, csvString: string) {

    console.log("Calling GenerateCSV " + fileName);

    let link = document.createElement("a");
    let blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    let url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${moment().format('YYYY-MM-DD')}_${fileName}`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/* Sanitize input value to csv */
export function SanitizeValueForCsv(fieldValue: string) {
    let parsedValue = "";

    if (fieldValue && fieldValue != 'undefined') {

        // Replace all double quotes with two double quotes
        parsedValue = fieldValue.replace(/"/g, `""`);

        // If value contains comma, new-line or double-quote, enclose in double quotes 
        parsedValue = /[",\n]/.test(parsedValue) ? `"${parsedValue}"` : parsedValue;
    }

    return parsedValue;

} 